export const EVENT_TYPE_VALUES = [
  "wedding",
  "corporate",
  "birthday",
  "gala",
  "school_party",
  "anniversary",
  "festival_public",
  "other",
] as const;

export type EventType = (typeof EVENT_TYPE_VALUES)[number];

export const EVENT_TYPE_LABELS: Record<EventType, string> = {
  wedding: "Bruiloft",
  corporate: "Bedrijfsfeest of bedrijfsevenement",
  birthday: "Verjaardag",
  gala: "Gala",
  school_party: "Schoolfeest",
  anniversary: "Jubileum",
  festival_public: "Festival of openbaar evenement",
  other: "Anders",
};

export const GUEST_COUNT_VALUES = ["under_50", "50_100", "100_200", "over_200", "unknown"] as const;

export type GuestCount = (typeof GUEST_COUNT_VALUES)[number];

export const GUEST_COUNT_LABELS: Record<GuestCount, string> = {
  under_50: "Minder dan 50",
  "50_100": "50 tot 100",
  "100_200": "100 tot 200",
  over_200: "Meer dan 200",
  unknown: "Nog niet bekend",
};

export const CUSTOM_PRINT_DESIGN_VALUES = ["yes", "maybe", "no", "unknown"] as const;

export type CustomPrintDesign = (typeof CUSTOM_PRINT_DESIGN_VALUES)[number];

export const CUSTOM_PRINT_DESIGN_LABELS: Record<CustomPrintDesign, string> = {
  yes: "Ja, graag",
  maybe: "Misschien, ik ontvang graag meer informatie",
  no: "Nee, een standaardontwerp is prima",
  unknown: "Ik weet het nog niet",
};

export const BOOKING_STATUS_VALUES = [
  "pending",
  "contacted",
  "approved",
  "rejected",
  "cancelled",
] as const;

export type BookingStatus = (typeof BOOKING_STATUS_VALUES)[number];

export const BOOKING_STATUS_LABELS: Record<BookingStatus, string> = {
  pending: "Nieuw",
  contacted: "Contact opgenomen",
  approved: "Goedgekeurd",
  rejected: "Afgewezen",
  cancelled: "Geannuleerd",
};
